import { IWidgetColor } from '@/types/components/widget';
import { RGBAColor } from '@shopify/polaris';

export const PAGE_SIZE = 10;

export const NUMBER_REGEX = /^\d*$/;

export const FILTER_NUMERIC_REGEX = /[^0-9]/g;

export const MAX_LENGTH_NUMBER = 15;

export const DELIMITER_OR_WHITESPACE_SEPARATOR = /[.,;:&\s]+/;

export const COMMA_AND_SEMICOLON_SEPARATOR = /[,;]+/;

export const WHITE_SPACE_AND_UNDERSCORE_REMOVER = /\s|_/g;

export const TRIM_SPECIAL_CHARS = /^[.,;:&\s]+|[.,;:&\s]+$/g;

export const DEFAULT_DATE_RANGE = '14';

export const DEFAULT_PREPARATION_TIME = '1';

export const DEFAULT_CUT_OFF_TIME = '2';

export const DEFAULT_FONT_SIZE = 14;

export const DEFAULT_ORDER_LIMIT = 0;

export const DEFAULT_WEEKLY_WORKING_DATA = [-1, 0, 1, 2, 3, 4, 5, 6].map((item) => ({
  id: item,
  settingId: -1,
  isEnable: true,
  day: item,
  preparationTime: {
    value: '1',
    unit: 'day',
  },
  isEnableCutOffTime: false,
  cutOffTime: '18:00',
  cutOffPreparationTime: {
    value: '2',
    unit: 'day',
  },
  dateRange: {
    value: '14',
    unit: 'day',
  },
  exactTimes: [
    {
      start: '14:00',
      orderLimit: 0,
    },
    {
      start: '16:00',
      orderLimit: 0,
    },
  ],
  timeSlots: [
    {
      start: '09:00',
      end: '16:00',
      orderLimit: DEFAULT_ORDER_LIMIT,
    },
  ],
  orderLimitPerDay: DEFAULT_ORDER_LIMIT,
  workingHours: { start: '09:00', end: '18:00' },
}));

export const DEFAULT_LIGHT_COLOR: RGBAColor = {
  red: 3,
  green: 7,
  blue: 18,
  alpha: 1,
};
export const DEFAULT_LIGHT_BACKGROUND_COLOR: RGBAColor = {
  red: 255,
  green: 255,
  blue: 255,
  alpha: 1,
};

export const DEFAULT_DARK_BACKGROUND_COLOR: RGBAColor = {
  red: 3,
  green: 7,
  blue: 18,
  alpha: 1,
};

export const DEFAULT_DARK_BORDER_SELECTED_COLOR: RGBAColor = {
  red: 255,
  green: 255,
  blue: 255,
  alpha: 1,
};

export const DEFAULT_DARK_BORDER_COLOR: RGBAColor = {
  red: 175,
  green: 175,
  blue: 175,
  alpha: 1,
};

export const DEFAULT_LIGHT_GRAY_COLOR: RGBAColor = {
  red: 156,
  green: 163,
  blue: 175,
  alpha: 1,
};

export const DEFAULT_LIGHT_SUCCESS_COLOR: RGBAColor = {
  red: 22,
  green: 163,
  blue: 74,
  alpha: 1,
};

export const DEFAULT_LIGHT_ERROR_COLOR: RGBAColor = {
  red: 220,
  green: 38,
  blue: 38,
  alpha: 1,
};

export const DEFAULT_DARK_COLOR: RGBAColor = {
  red: 255,
  green: 255,
  blue: 255,
  alpha: 1,
};

export const DEFAULT_DARK_ERROR_COLOR: RGBAColor = {
  red: 255,
  green: 0,
  blue: 0,
  alpha: 1,
};

export const DEFAULT_DARK_SUCCESS_COLOR: RGBAColor = {
  red: 0,
  green: 255,
  blue: 94,
  alpha: 1,
};

export const DEFAULT_LIGHT_COLORS_SETTINGS: IWidgetColor = {
  id: 1,
  calendar: {
    calendarBackground: DEFAULT_LIGHT_BACKGROUND_COLOR,
    calendarBorder: DEFAULT_LIGHT_COLOR,
    selectedDateColor: DEFAULT_LIGHT_BACKGROUND_COLOR,
    selectedDateBackgroundColor: DEFAULT_LIGHT_COLOR,
    availableDateColor: DEFAULT_LIGHT_COLOR,
    unavailableDateColor: DEFAULT_LIGHT_GRAY_COLOR,
  },
  header: {
    headerTitleColor: DEFAULT_LIGHT_COLOR,
    buttonColor: DEFAULT_LIGHT_COLOR,
    buttonBackground: DEFAULT_LIGHT_BACKGROUND_COLOR,
    buttonBorder: DEFAULT_LIGHT_GRAY_COLOR,
    hoverButtonBackground: DEFAULT_LIGHT_BACKGROUND_COLOR,
    hoverButtonColor: DEFAULT_LIGHT_COLOR,
    hoverButtonBorder: DEFAULT_LIGHT_COLOR,
    selectedButtonBackground: DEFAULT_LIGHT_BACKGROUND_COLOR,
    selectedButtonColor: DEFAULT_LIGHT_COLOR,
    selectedButtonBorder: DEFAULT_LIGHT_COLOR,
    dateTitleColor: DEFAULT_LIGHT_COLOR,
    timeTitleColor: DEFAULT_LIGHT_COLOR,
    inputBackground: DEFAULT_LIGHT_BACKGROUND_COLOR,
    inputBorder: DEFAULT_LIGHT_COLOR,
    inputTextDateColor: DEFAULT_LIGHT_COLOR,
    inputTextTimeColor: DEFAULT_LIGHT_COLOR,
  },
  body: {
    inputColor: DEFAULT_LIGHT_COLOR,
    inputBackground: DEFAULT_LIGHT_BACKGROUND_COLOR,
    inputBorder: DEFAULT_LIGHT_COLOR,
    checkButtonColor: DEFAULT_LIGHT_COLOR,
    checkButtonBackground: DEFAULT_LIGHT_BACKGROUND_COLOR,
    checkButtonBorder: DEFAULT_LIGHT_COLOR,
    eligibleMessageColor: DEFAULT_LIGHT_SUCCESS_COLOR,
    requiredMessageColor: DEFAULT_LIGHT_COLOR,
    errorColor: DEFAULT_LIGHT_ERROR_COLOR,
    additionalNotesColor: DEFAULT_LIGHT_COLOR,
  },
};

export const VALID_YYYY_MM_DD_DATE_REGEX = /^\d{4}-\d{1,2}-\d{1,2}/;

export const DEFAULT_ORDER_COLUMN = [
  { key: 'order', label: 'Order', visible: true },
  { key: 'createdAt', label: 'Created at', visible: true },
  { key: 'item', label: 'Item', visible: true },
  { key: 'total', label: 'Total', visible: true },
  { key: 'payment', label: 'Payment', visible: true },
  { key: 'dueDate', label: 'Due date', visible: true },
  { key: 'method', label: 'Method', visible: true },
  { key: 'location', label: 'Location', visible: true },
  { key: 'shipTo', label: 'Ship to', visible: true },
  { key: 'status', label: 'Status', visible: true },
  { key: 'customer', label: 'Customer', visible: true },
];

export const DEFAULT_DARK_COLORS_SETTINGS: IWidgetColor = {
  id: 1,
  calendar: {
    calendarBackground: DEFAULT_DARK_BACKGROUND_COLOR,
    calendarBorder: DEFAULT_DARK_BORDER_SELECTED_COLOR,
    selectedDateColor: DEFAULT_DARK_BACKGROUND_COLOR,
    selectedDateBackgroundColor: DEFAULT_LIGHT_BACKGROUND_COLOR,
    availableDateColor: DEFAULT_DARK_COLOR,
    unavailableDateColor: DEFAULT_DARK_COLOR,
  },
  header: {
    headerTitleColor: DEFAULT_DARK_COLOR,
    buttonColor: DEFAULT_DARK_COLOR,
    buttonBackground: DEFAULT_DARK_BACKGROUND_COLOR,
    buttonBorder: DEFAULT_DARK_BORDER_COLOR,
    hoverButtonBackground: DEFAULT_DARK_BACKGROUND_COLOR,
    hoverButtonColor: DEFAULT_DARK_COLOR,
    hoverButtonBorder: DEFAULT_DARK_BORDER_COLOR,
    selectedButtonBackground: DEFAULT_DARK_BACKGROUND_COLOR,
    selectedButtonColor: DEFAULT_DARK_COLOR,
    selectedButtonBorder: DEFAULT_DARK_BORDER_SELECTED_COLOR,
    dateTitleColor: DEFAULT_DARK_COLOR,
    timeTitleColor: DEFAULT_DARK_COLOR,
    inputBackground: DEFAULT_DARK_BACKGROUND_COLOR,
    inputBorder: DEFAULT_LIGHT_COLOR,
    inputTextDateColor: DEFAULT_DARK_COLOR,
    inputTextTimeColor: DEFAULT_DARK_COLOR,
  },
  body: {
    inputColor: DEFAULT_LIGHT_COLOR,
    inputBackground: DEFAULT_LIGHT_BACKGROUND_COLOR,
    inputBorder: DEFAULT_LIGHT_COLOR,
    checkButtonColor: DEFAULT_DARK_COLOR,
    checkButtonBackground: DEFAULT_DARK_BACKGROUND_COLOR,
    checkButtonBorder: DEFAULT_DARK_COLOR,
    eligibleMessageColor: DEFAULT_DARK_SUCCESS_COLOR,
    requiredMessageColor: DEFAULT_LIGHT_COLOR,
    errorColor: DEFAULT_DARK_ERROR_COLOR,
    additionalNotesColor: DEFAULT_DARK_COLOR,
  },
};

export const REGEX_EMAIL = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
